 import React, { useRef, useState, useLayoutEffect } from 'react';
 import { RemoveButton } from './Buttons.jsx';
 
 export function PanelContainer({ children, basic }) {
   return (
     <div
       className={`flex flex-col h-full ${basic ? 'bg-transparent' : 'bg-white border border-gray-300 rounded-2xl overflow-hidden shadow-lg select-none'}`}
       style={{ contain: 'content' }}
     >
       {children}
     </div>
   );
 }
 
 export function PanelLoader({ id, type, data, onRemove, children, basic = false }) {
   if (data?.isLoading) {
      const typeLabel = type === 'numericPlot' ? 'Distribution' : type === 'scatterplot' ? 'Scatterplot' : type.charAt(0).toUpperCase() + type.slice(1);
      const displayFilename = data.filename || 'Loading...';
      return (
        <PanelContainer id={id} basic={basic}>
          {!basic && (
            <div className={`panel-header ${!basic ? 'cursor-move' : ''}`}>
              <span className="truncate ml-2">{typeLabel}: {displayFilename}</span>
              <div className="flex items-center gap-0.5">
                {onRemove && <RemoveButton onClick={() => onRemove(id)} />}
              </div>
            </div>
          )}
          <div className="flex flex-col items-center justify-center h-full w-full bg-white relative z-10 p-4 text-center">
            <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full mb-3" />
            <span className="text-sm text-gray-500 font-bold animate-pulse">
              {displayFilename.startsWith('Merging') ? 'Merging tables...' : `Rendering ${typeLabel}...`}
            </span>
            <span className="text-xs text-gray-400 mt-2 max-w-[80%]">This might take a few moments depending on the dataset size.</span>
          </div>
        </PanelContainer>
      );
   }
   return children;
 }
 
 // InteractionWrapper: Freezes the size and interactions of inner content during RGL drags/resizes
 export function InteractionWrapper({ isInteracting, children }) {
   const containerRef = useRef(null);
   const [frozenStyle, setFrozenStyle] = useState(null);
 
   useLayoutEffect(() => {
     if (isInteracting && containerRef.current) {
    // Freeze the exact pixel size before the browser recalculates the layout
       const { offsetWidth, offsetHeight } = containerRef.current;
       setFrozenStyle({ width: `${offsetWidth}px`, height: `${offsetHeight}px`, position: 'absolute', top: 0, left: 0, pointerEvents: 'none', opacity: 0.6, zIndex: 50 });
     } else {
       // Unfreeze  
       setFrozenStyle(null);
     }
   }, [isInteracting]);
 
   return <div ref={containerRef} className="w-full h-full relative overflow-hidden rounded-2xl"><div style={frozenStyle || { width: '100%', height: '100%' }}>{children}</div></div>;
 }